import { handleActions } from 'redux-actions';

import { FETCH_BRANCHES, FETCH_BRANCHES_SELECT_DATA } from '../constants/index';

const initialState = {
  branches: [],
  selectData: {},
};

export const branches = handleActions(
  {
    [FETCH_BRANCHES]: (state = initialState, action = {}) => ({
      ...state,
      branches: action.payload,
    }),
    [FETCH_BRANCHES_SELECT_DATA]: (state = initialState, action = {}) => ({
      ...state,
      selectData: action.payload,
    }),
  },
  initialState,
);
